// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__6VHhf","colMin":"styles_colMin__Ls7dP"};